import React from 'react';
import {  NavLink } from 'react-router-dom';
const menus = [
    {
        name:'Men',
        target:'/category/men',
    },
    {
        name:'Women',
        target:'/category/women',

    }
]
const NavOtherLink = () => {
    return(
        <ul className="hidden lg:flex navbar-list">
            {menus.map((item,i)=>{
                return(
                    <li key={i} className={item.className}>
                        <NavLink exact to={item.target} activeClassName="active font-bold lg:font-normal" className="navbar-link font-light block xl:text-lg py-10 cursor-pointer hover:text-gray-400 lg:px-16">{item.name}</NavLink>
                    </li>
                );
            })}
            
        </ul>
    )
}
export default NavOtherLink;